import { render, staticRenderFns } from "./TopMenuSubheadline.vue?vue&type=template&id=2182cf15&scoped=true&"
import script from "./TopMenuSubheadline.vue?vue&type=script&lang=js&"
export * from "./TopMenuSubheadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2182cf15",
  null
  
)

export default component.exports